import { Step, AppUuidConfig } from '../../types';

export const getStepsFromAppUuidConfig = (
  config: AppUuidConfig | null
): Step[] => {
  if (!config) return [];

  const { steps = [] } = config;
  return steps;
};
